var _defs, _clipPath, _linearGradient, _path, _defs2, _clipPath2, _linearGradient2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBpost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 110,
    viewBox: "100.88 296.9 130.21 71.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M173.35 303.51c-8.53 18.61-28.44 37.67-44.48 42.52-16.07 4.87-22.1-6.34-13.48-25l-8.5 2.57c-4.05 8.75-5.98 16.43-6.01 22.66v.26c.06 13.87 9.68 20.39 26.57 15.27 24.48-7.43 54.86-36.53 67.82-64.9l-21.92 6.62z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#a"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -12.73,
    x2: -11.73,
    y1: -15.43,
    y2: -15.43,
    gradientTransform: "rotate(-35 2610.44 -3048.21) scale(109.6536)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a40d11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#a60e13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#c51521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d81829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#df192b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df192b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M164.22 252.55l63.95 91.33-96.24 67.38-63.95-91.33z",
    clipPath: "url(#c)"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M119.23 319.86c-4.4 9.52-1.33 15.23 6.86 12.75 8.19-2.47 18.35-12.18 22.72-21.68l-29.58 8.93z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#d"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -14.47,
    x2: -13.47,
    y1: -29.25,
    y2: -29.25,
    gradientTransform: "rotate(-35 2021.65 -1400.25) scale(36.676)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a40d11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#a60e13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#c51521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d81829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#df192b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df192b"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M137.63 294.97l22.53 32.17L126 351.05l-22.53-32.17z",
    clipPath: "url(#f)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M186.39 363.3c-.8 0-1.7-.14-2.16-.28v5.22h-3.8v-17.16c1.12-.5 3.23-.92 5.49-.92 4.84 0 7.47 2.46 7.47 6.57 0 3.93-2.42 6.57-7 6.57m-.42-10.64c-.69 0-1.41.1-1.74.26v7.68c.3.13 1.1.24 1.77.24 2.36 0 3.59-1.69 3.59-4.1 0-2.58-1.29-4.08-3.62-4.08m16.1 10.78c-4.35 0-6.78-2.85-6.78-6.66 0-3.8 2.43-6.62 6.78-6.62 4.36 0 6.78 2.82 6.78 6.62 0 3.81-2.42 6.66-6.78 6.66m0-10.76c-2 0-3 1.53-3 4.09 0 2.54 1 4.05 3 4.05 2.02 0 3-1.51 3-4.05 0-2.55-.99-4.1-3-4.1m13.06 10.77a12.8 12.8 0 01-4.86-.92l1.23-2.45c.74.4 2.43.82 3.5.82 1.38 0 2.26-.54 2.26-1.4 0-.93-.97-1.34-2.31-1.74-1.9-.59-4.28-1.35-4.28-3.85 0-2.24 2-3.75 5.5-3.75 1.93 0 3.48.4 4.62.92l-1.17 2.2a7.53 7.53 0 00-2.98-.73c-1.33 0-2.12.56-2.12 1.32 0 .97.98 1.35 2.29 1.75 1.97.6 4.4 1.32 4.4 3.89 0 2.39-2.1 3.94-6.08 3.94m13.7-.1c-2.9 0-4.27-1.34-4.27-4v-6.5h-1.93v-2.4h1.93v-2.84l3.72-.91v3.75h2.81v2.4h-2.81v6.28c0 1.04.76 1.4 1.73 1.4.4 0 .82-.1 1.08-.2V363a7 7 0 01-2.27.34m-50.8-6.6c0 4.12-2.65 6.58-7.49 6.58-2.26 0-4.36-.42-5.48-.93v-17.15h3.78v5.22a8.54 8.54 0 012.16-.28c4.6 0 7.02 2.64 7.02 6.55m-3.81 0c0-2.4-1.22-4.1-3.59-4.1-.67 0-1.46.11-1.77.23v7.7a5.2 5.2 0 001.74.26c2.35 0 3.62-1.51 3.62-4.09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpost);
export default __webpack_public_path__ + "static/media/bpost.b2aadb266a2b9010601b088a3dc50c23.svg";
export { ForwardRef as ReactComponent };